/**
 * Navbar landing — fixe en haut, fond transparent → sombre au scroll.
 */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { colors, fonts } from "../../styles/tokens";
import Logo from "../Logo";
import Button from "../Button";
import SwitchDevise from "../SwitchDevise";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToId = (id) => (e) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <nav
        style={{
          position: "fixed",
          top: 0, left: 0, right: 0,
          width: "100%",
          maxWidth: "100%",
          overflowX: "hidden",
          zIndex: 100,
          padding: "16px 1rem",
          background: scrolled ? "rgba(5,7,9,0.95)" : "transparent",
          backdropFilter: scrolled ? "blur(12px)" : "none",
          borderBottom: scrolled ? `1px solid ${colors.border}` : "1px solid transparent",
          transition: "all 250ms ease-out",
          fontFamily: fonts.body,
        }}
      >
        <div style={{
          maxWidth: 1200,
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "20px",
        }}>
          <Link to="/" style={{ textDecoration: "none" }}>
            <Logo size="sm" showName />
          </Link>

          {/* Liens desktop */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }} className="nav-desktop">
            <a
              href="#fonctionnalites"
              onClick={scrollToId("fonctionnalites")}
              style={navLinkStyle}
              onMouseEnter={(e) => { e.target.style.color = colors.gold; }}
              onMouseLeave={(e) => { e.target.style.color = colors.textMuted; }}
            >
              Fonctionnalités
            </a>
            <a
              href="#tarifs"
              onClick={scrollToId("tarifs")}
              style={navLinkStyle}
              onMouseEnter={(e) => { e.target.style.color = colors.gold; }}
              onMouseLeave={(e) => { e.target.style.color = colors.textMuted; }}
            >
              Tarifs
            </a>
            <SwitchDevise compact />
            <Link to="/connexion" style={{ textDecoration: "none" }}>
              <Button variant="ghost" size="sm">Se connecter</Button>
            </Link>
            <Link to="/inscription" style={{ textDecoration: "none" }}>
              <Button size="sm">Commencer →</Button>
            </Link>
          </div>

          {/* Burger mobile */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
            className="nav-burger"
            style={{
              display: "none",
              color: colors.text,
              fontSize: "24px",
              padding: "4px 8px",
            }}
          >
            ☰
          </button>
        </div>
      </nav>

      {/* Drawer mobile */}
      {mobileOpen && (
        <div
          onClick={() => setMobileOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.7)",
            zIndex: 90,
            animation: "fadeIn 200ms",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "absolute",
              top: 64, right: 16, left: 16,
              background: colors.surface,
              border: `1px solid ${colors.border}`,
              borderRadius: "14px",
              padding: "12px",
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              boxShadow: "0 12px 32px rgba(0,0,0,0.6)",
            }}
          >
            <a href="#fonctionnalites" onClick={scrollToId("fonctionnalites")} style={mobileLinkStyle}>Fonctionnalités</a>
            <a href="#tarifs" onClick={scrollToId("tarifs")} style={mobileLinkStyle}>Tarifs</a>
            <div style={{ padding: "8px 14px" }}>
              <SwitchDevise />
            </div>
            <div style={{ height: 1, background: colors.border, margin: "4px 0" }} />
            <Link to="/connexion" style={{ textDecoration: "none" }}>
              <Button variant="ghost" fullWidth>Se connecter</Button>
            </Link>
            <Link to="/inscription" style={{ textDecoration: "none" }}>
              <Button fullWidth>Commencer →</Button>
            </Link>
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .nav-desktop { display: none !important; }
          .nav-burger { display: inline-flex !important; }
        }
      `}</style>
    </>
  );
}

const navLinkStyle = {
  color: colors.textMuted,
  fontSize: "14px",
  fontWeight: 500,
  padding: "8px 14px",
  textDecoration: "none",
  transition: "color 150ms",
};

const mobileLinkStyle = {
  color: colors.text,
  fontSize: "15px",
  padding: "10px 14px",
  borderRadius: "8px",
  textDecoration: "none",
};
